import React from 'react'
import PropTypes from 'prop-types'

import {
  BannerContainer,
  TextContainer,
  SubLabel,
  Disclosure,
  PromoHeader,
  // DiscountText,
  StyledText,
  DisclosureTextContainer,
} from './styles'
import { IN_SEASONAL_STATE, VIP_CODE } from '../../../utils/constants'

export const BfcmPdpBanner = ({
  frame,
  promoHeader,
  promoSubHeader = {},
  disclaimerText1,
  disclaimerText2,
  // discountText,
  // discountTextColor,
  promoBannerBkgdColor,
  promoCode,
}) => {
  const { preStyledText, styledText, postStyledText, styledTextColor } = promoSubHeader
  return (
    <BannerContainer promoBannerBkgdColor={promoBannerBkgdColor}>
      <TextContainer>
        <PromoHeader>{promoHeader}</PromoHeader>
        {/* <DiscountText color={discountTextColor}>{discountText}</DiscountText> */}
        {promoSubHeader && (
          <SubLabel>
            {preStyledText}{' '}
            {promoCode === VIP_CODE ? null : frame && IN_SEASONAL_STATE ? 'Frames' : 'Calendars'}{' '}
            <StyledText styledTextColor={styledTextColor}>{styledText}</StyledText>
            {postStyledText}
          </SubLabel>
        )}
        <DisclosureTextContainer>
          <Disclosure dangerouslySetInnerHTML={{ __html: disclaimerText1 }} />
          {disclaimerText2 && <Disclosure>{disclaimerText2}</Disclosure>}
        </DisclosureTextContainer>
      </TextContainer>
    </BannerContainer>
  )
}

BfcmPdpBanner.propTypes = {
  frame: PropTypes.bool,
  promoHeader: PropTypes.string.isRequired,
  promoSubHeader: PropTypes.object,
  disclaimerText1: PropTypes.string.isRequired,
  disclaimerText2: PropTypes.string,
  // discountTextColor: PropTypes.string.isRequired,
  promoBannerBkgdColor: PropTypes.string.isRequired,
  promoCode: PropTypes.string,
  // discountText: PropTypes.string.isRequired,
}
